import { dateFnsLocalizer } from 'react-big-calendar';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import startOfWeek from 'date-fns/startOfWeek';
import getDay from 'date-fns/getDay';
import { uk } from 'date-fns/locale';

const locales = {
    uk
};

const START_OF_WEEK_MONDAY = 1;

export default dateFnsLocalizer({
    format,
    parse,
    startOfWeek: (date: Date, locale: Locale) => startOfWeek(date, { locale, weekStartsOn: START_OF_WEEK_MONDAY }),
    getDay,
    locales
});

const CultureMapping: { [key: string]: string } = {
    ua: 'uk'
};

export const getCulture = (locale: string): string => CultureMapping[locale] || locale;
